import React from 'react';
import { Provider } from 'react-redux';
import { HYDRATE_ACTION_TYPE } from './action-types.js';

function createWrapperInitializer(storeCreator, initializerOptions = {}) {
  let anyStore;
  let appEggsLocal = [];
  let appHasGetInitialProps = false;
  let beforeResult;
  let prevPage;
  let prevState;
  const runBeforeResult = async context => {
    if (beforeResult) {
      await beforeResult(anyStore, {
        context
      });
    }
  };
  const add = nextPage => {
    if (nextPage !== prevPage) {
      const pageEggs = nextPage.__eggs || [];
      anyStore.addEggs(prevPage ? pageEggs : [].concat(appEggsLocal, pageEggs));
      prevPage = nextPage;
    }
  };
  const hydrate = payload => {
    if (prevState !== payload) {
      if (payload) {
        anyStore.dispatch({
          type: initializerOptions.hydrationActionType || HYDRATE_ACTION_TYPE,
          payload
        });
      }
      prevState = payload;
    }
  };
  return {
    getAppWrapper(appEggs = [], options = {}) {
      appEggsLocal = appEggs;
      beforeResult = options.beforeResult;
      return {
        wrapGetInitialProps(fn) {
          appHasGetInitialProps = true;
          return async context => {
            add(context.Component);
            const appProps = await fn(anyStore)(context);
            await runBeforeResult(context);
            return appProps;
          };
        },
        wrapApp(AppComponent) {
          return class WrappedApp extends React.Component {
            static getInitialProps = AppComponent.getInitialProps;
            constructor(props) {
              super(props);
              if (!anyStore) {
                anyStore = storeCreator();
              }
              add(props.Component);
              hydrate(props.pageProps.__eggsState);
            }
            shouldComponentUpdate(nextProps) {
              add(nextProps.Component);
              if (!nextProps.Component.getInitialProps) {
                hydrate(nextProps.pageProps.__eggsState);
              }
              return true;
            }
            componentDidUpdate(prevProps) {
              const prevComponent = prevProps.Component;
              if (prevComponent.__eggs?.length && this.props.Component !== prevComponent) {
                anyStore.removeEggs(prevComponent.__eggs);
              }
            }
            render() {
              delete this.props.pageProps.__eggsState;
              return /*#__PURE__*/React.createElement(Provider, {
                store: anyStore
              }, /*#__PURE__*/React.createElement(AppComponent, this.props));
            }
          };
        }
      };
    },
    getPageWrapper(pageEggs = []) {
      let currentPage;
      return {
        wrapGetInitialProps(fnOrProps) {
          const localFn = typeof fnOrProps === 'function' ? fnOrProps : () => () => ({
            ...fnOrProps
          });
          return async context => {
            if (!appHasGetInitialProps) {
              add(currentPage);
            }
            const pageProps = await localFn(anyStore)(context);
            if (!appHasGetInitialProps) {
              await runBeforeResult(context);
            }
            return pageProps;
          };
        },
        wrapPage(page) {
          currentPage = page;
          currentPage.__eggs = pageEggs;
          return page;
        }
      };
    }
  };
}

export { HYDRATE_ACTION_TYPE, createWrapperInitializer };
